module.exports = __webpack_public_path__ + "img/quem-somos-img-100.e3bc21fe.jpg";